import { createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';

import { automodeApi } from 'src/api';

export const createAutomode = createAsyncThunk(
  'automode/create-automode',
  async (data, thunkApi) => {
    try {
      const { payload, onCancel } = data;

      const response = await automodeApi.createAutomode(payload);

      toast(response.data.message, { type: 'success' });

      thunkApi.dispatch(fetchAutomodes({}));

      if (onCancel) {
        onCancel();
      }

      return response.data;
    } catch (error) {
      console.error('createAutomode[error]', error);

      const message = error?.response?.data?.message || 'Something went wrong';

      toast(message, { type: 'error' });

      return thunkApi.rejectWithValue(message);
    }
  }
);

export const fetchAutomodes = createAsyncThunk(
  'automode/fetch-automodes',
  async (data, thunkApi) => {
    try {
      const response = await automodeApi.fetchAutomodes(data);

      return response.data;
    } catch (error) {
      console.error('fetchAutomodes[error]', error);

      const message = error?.response?.data?.message || 'Something went wrong';

      toast(message, { type: 'error' });

      return thunkApi.rejectWithValue(message);
    }
  }
);

export const updateAutomode = createAsyncThunk(
  'automode/update-automode',
  async (data, thunkApi) => {
    try {
      const { id, payload, onCancel } = data;

      const response = await automodeApi.updateAutomode(id, payload);

      toast(response.data.message, { type: 'success' });

      thunkApi.dispatch(fetchAutomodes({}));

      if (onCancel) {
        onCancel();
      }

      return response.data;
    } catch (error) {
      console.error('updateAutomode[error]', error);

      const message = error?.response?.data?.message || 'Something went wrong';

      toast(message, { type: 'error' });

      return thunkApi.rejectWithValue(message);
    }
  }
);

export const deleteAutomode = createAsyncThunk(
  'automode/delete-automode',
  async (data, thunkApi) => {
    try {
      const { id } = data;

      const response = await automodeApi.deleteAutomode(id);

      toast(response.data.message, { type: 'success' });

      thunkApi.dispatch(fetchAutomodes({}));

      return response.data;
    } catch (error) {
      console.error('deleteAutomode[error]', error);

      const message = error?.response?.data?.message || 'Something went wrong';

      toast(message, { type: 'error' });

      return thunkApi.rejectWithValue(message);
    }
  }
);
